import type {SuggestLocation} from '@yandex-delivery/api/model/suggest'
import {SuggestAction} from '@yandex-delivery/api/model/suggest'
import {merge, pipe} from '@yandex-delivery/utils'

import type {AddressSuggestResponse, Order as FormValues} from '../../types'
import {fromPinDropToPointAddress} from '../../utils'
import {suggestService} from './fetch-address-suggest'

const {fetchAddressSuggest} = suggestService
export async function fetchAddressFromInitialProps(zonePoint: SuggestLocation) {
  const source = await fetchAddressSuggest({
    point: zonePoint,
    type: 'a',
    location: zonePoint,
    action: SuggestAction.PIN_DROP,
  })
    .then(res => res as unknown as AddressSuggestResponse)
    .then(fromPinDropToPointAddress)

  const addressFromInitialProps = {
    sourcePoint: {
      address: source,
    },
  }

  return function _withAddressFromInitialProps(
    defaultValues: FormValues,
  ): FormValues {
    return pipe(addressFromInitialProps, merge(defaultValues))
  }
}
